module.exports = __webpack_public_path__ + "media/configurations/SV_O-X-X-2d1f9edb.png";